/**
 * users sagas
 */
import { call, put, select, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import get from 'lodash.get';
import { stopSubmit } from 'redux-form';

// Types
import { Saga } from 'redux-saga';

// Constants
import {
    USERS_ME_LOAD_REQUESTED,
    USERS_ME_UPDATE_REQUESTED
} from './constants';

// Actions
import {
    setUsersMe,
    usersMeLoaded,
    usersMeLoadingError,
    updateUsersMeSucceeded,
    updateUsersMeFailed
} from './actions';

// Selectors
import { idTokenSelector } from '../auth/selectors';

// Utils
import axiosRetry from '../../utils/axiosRetry';

// Environment
const { REACT_APP_API_URL } = process.env;

export function* getUsersMe(): Saga<void> {
    const filter = JSON.stringify({
        eager: 'roleMappings'
    });
    const config = {
        method: 'get',
        url: `${REACT_APP_API_URL}/v1/Users/me?filter=${filter}`
    };

    try {
        const { data } = yield call(axiosRetry, config);
        yield put(setUsersMe(data));
        yield put(usersMeLoaded(data));
    } catch (error) {
        yield put(usersMeLoadingError(error));
    }
}

export function* watchLoadUsersMe(): Saga<void> {
    yield takeLatest(USERS_ME_LOAD_REQUESTED, getUsersMe);
}

export function* patchUsersMe({ payload }): Saga<void> {
    // Select ID Token
    const idToken = yield select(idTokenSelector);

    const config = {
        method: 'patch',
        url: `${REACT_APP_API_URL}/v1/Users/me`,
        headers: {
            Authorization: idToken
        },
        data: payload
    };

    try {
        const { data } = yield call(axios, config);
        yield put(setUsersMe(data));
        yield put(updateUsersMeSucceeded(data));
    } catch (error) {
        yield put(updateUsersMeFailed(error));

        const message = get(
            error,
            'response.data.message',
            'There was an error. Please try again later.'
        );

        // Redux form error
        yield put(stopSubmit('usersMeForm', { _error: message }));
    }
}

export function* watchUsersMeUpdateRequested(): Saga<void> {
    yield takeLatest(USERS_ME_UPDATE_REQUESTED, patchUsersMe);
}
